/* ============================================================================
   McDuffy Quiz v2 — RECOVERY OVERLAYS
   ----------------------------------------------------------------------------
   The high-value overlays ported from the live quiz (copy + sampler URLs kept
   verbatim), rebuilt in the clean v2 theme. Mounted once by boot after the view.

   - Global popup suppressor (mandatory) — stops the site-wide popup hijacking.
   - Objection capture ("what's holding you back") at the price moment → the
     honest downsell (mix-with-current-food / ₱499 sampler / picky-pup promise).
   - Exit-intent rescue on the input screens (mobile-triggered).
   - beforeunload dropoff telemetry.

   Exposes window.MQ_Overlays.init(rootEl, { track, getScreen, getDogName, isDone }).
   Premium voice; never cheap/budget/value/basic/affordable/lower-tier.
   ============================================================================ */
(function () {
  'use strict';

  var SAMPLER_PRICE_URL = '/products/mcduffys-gently-home-cooked-complete-dog-food?view=one-time-shop-v8&utm_source=quiz_objection&utm_campaign=price#trial=sampler&sampler=custom';
  var SAMPLER_RECIPES_URL = '/products/mcduffys-gently-home-cooked-complete-dog-food?view=one-time-shop-v8&utm_source=quiz_objection&utm_campaign=recipes#trial=sampler&sampler=custom';

  function el(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstElementChild; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init(rootEl, opts) {
    opts = opts || {};
    var track = opts.track || function () {};
    var getScreen = opts.getScreen || function () { return ''; };
    var getDogName = opts.getDogName || function () { return 'your dog'; };
    var isDone = opts.isDone || function () { return false; };
    var shownExit = false, shownObjection = false;

    /* ---- global popup suppressor (port of live MutationObserver) ---- */
    function suppress() {
      var n = document.getElementById('mcduffy-popup-overlay'); if (n) n.remove();
      [].forEach.call(document.querySelectorAll('.mcduffy-popup-overlay, .mcduffy-side-tab'), function (x) { x.remove(); });
    }
    try { suppress(); new MutationObserver(suppress).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}

    /* ---- overlay scaffold ---- */
    var host = el('<div class="mq-overlay" hidden role="dialog" aria-modal="true"><div class="mq-overlay__scrim" data-ov-dismiss></div><div class="mq-overlay__card" data-ov-card></div></div>');
    rootEl.appendChild(host);
    var card = host.querySelector('[data-ov-card]');
    function open(html) { card.innerHTML = html; host.hidden = false; document.body.classList.add('mq-ov-open'); }
    function close() { host.hidden = true; document.body.classList.remove('mq-ov-open'); }

    host.addEventListener('click', function (e) {
      if (e.target.closest('[data-ov-dismiss]')) { close(); return; }
      var b = e.target.closest('[data-objection]'); if (b) { showObjectionBranch(b.getAttribute('data-objection')); return; }
      if (e.target.closest('[data-ov-continue]')) { track('quiz_exit_intent_continued', {}); close(); return; }
      if (e.target.closest('[data-ov-back]')) { showObjectionAsk(); return; }
    });

    function showObjectionAsk() {
      open(
        '<h3 class="mq-overlay__h">Before you go — what’s holding you back?</h3>' +
        '<p class="mq-overlay__sub">No pressure — your plan stays saved either way.</p>' +
        '<div class="mq-overlay__opts">' +
          '<button type="button" class="mq-overlay__opt" data-objection="price">💰 The monthly price</button>' +
          '<button type="button" class="mq-overlay__opt" data-objection="recipes">🍽 Not sure my dog will eat it</button>' +
          '<button type="button" class="mq-overlay__opt" data-objection="think">🤔 I need to think about it</button>' +
        '</div>' +
        '<button type="button" class="mq-overlay__dismiss" data-ov-dismiss>Just browsing</button>'
      );
      track('quiz_objection', { reason: 'shown' });
    }
    function showObjectionBranch(reason) {
      track('quiz_objection', { reason: reason });
      if (reason === 'price') {
        open(
          '<h3 class="mq-overlay__h">Two honest ways to lower it</h3>' +
          '<p class="mq-overlay__p"><strong>Mix with your current food</strong> — many families feed half-fresh. Switch to Chicken It Up on your plan and the price recalculates instantly.</p>' +
          '<p class="mq-overlay__p">Or <strong>taste-test first</strong>: 3 fresh meals for ₱499, one-time, COD available.</p>' +
          '<a class="mq-overlay__cta" href="' + SAMPLER_PRICE_URL + '">Build your ₱499 sampler — pick any 3</a>' +
          '<button type="button" class="mq-overlay__dismiss" data-ov-back>← Back to my plan</button>'
        );
      } else if (reason === 'recipes') {
        open(
          '<h3 class="mq-overlay__h">Picky pups are our specialty</h3>' +
          '<p class="mq-overlay__p">Real meat smells like food, not pellets — most picky dogs flip in days. And if yours doesn’t? Message us within 14 days and we make it right.</p>' +
          '<a class="mq-overlay__cta" href="' + SAMPLER_RECIPES_URL + '">Let the bowl decide — ₱499</a>' +
          '<button type="button" class="mq-overlay__dismiss" data-ov-back>← Back to my plan</button>'
        );
      } else {
        open(
          '<h3 class="mq-overlay__h">Totally fair — it’s saved</h3>' +
          '<p class="mq-overlay__p">Your dog’s plan and price are saved to your email. The kitchen plans by the week, so the sooner you start, the sooner the first fresh bowl lands.</p>' +
          '<button type="button" class="mq-overlay__cta" data-ov-dismiss>Got it</button>'
        );
      }
    }
    function showRescue() {
      open(
        '<h3 class="mq-overlay__h">Wait — ' + esc(getDogName()) + '’s plan is almost ready</h3>' +
        '<p class="mq-overlay__p">A couple more taps and you’ll see the exact portions, recipes, and price<span class="mq-introonly"> — with 40% off first-box food</span>.</p>' +
        '<button type="button" class="mq-overlay__cta" data-ov-continue>Show me the plan &amp; price</button>' +
        '<button type="button" class="mq-overlay__dismiss" data-ov-dismiss>No thanks</button>'
      );
      track('quiz_exit_intent_shown', {});
    }

    /* ---- triggers ---- */
    /* NOTE: 'reveal' is the async loading screen (no price shown yet) → it must take the
       exit-intent RESCUE branch, not the price-objection branch. Only real price screens here. */
    var PRICE_SCREENS = { plan: 1, review: 1 };
    var initTime = Date.now();
    function canFire() {
      if (!host.hidden || isDone()) return false;
      var scr = getScreen();
      if (PRICE_SCREENS[scr]) return !shownObjection;
      return !!(scr && scr !== 'welcome' && !shownExit);
    }
    function fire() {
      if (!canFire()) return;
      var scr = getScreen();
      if (PRICE_SCREENS[scr]) { shownObjection = true; showObjectionAsk(); }
      else { shownExit = true; showRescue(); }
    }
    /* desktop: cursor leaves toward the top */
    document.addEventListener('mouseout', function (e) { if (e.clientY <= 0 && !e.relatedTarget) fire(); });
    /* mobile: history back-button intercept — re-arm + show ONLY while an overlay can still
       fire for this screen. Once the guards are spent (or the overlay is closed), a Back press
       navigates away normally — never a permanent Back-button trap. */
    try {
      history.pushState({ mqov: 1 }, '');
      window.addEventListener('popstate', function () {
        if (!host.hidden) { close(); return; }                 /* open overlay → Back just closes it */
        if (canFire()) { history.pushState({ mqov: 1 }, ''); fire(); } /* else: let the Back navigation proceed */
      });
    } catch (e) {}
    /* mobile: a deliberate fast flick to the very top, AFTER some dwell — conservative so iOS
       momentum / rubber-band scrolling near the top doesn't false-fire on an engaged buyer. */
    var lastY = 0, lastT = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY || window.pageYOffset || 0, t = Date.now();
      if (y <= 4 && (lastY - y) > 160 && (t - lastT) < 300 && (t - initTime) > 6000) fire();
      lastY = y; lastT = t;
    }, { passive: true });

    /* ---- dropoff telemetry (only if the user hasn't converted) ---- */
    window.addEventListener('beforeunload', function () { if (!isDone()) { try { track('quiz_dropoff', { screen: getScreen() }); } catch (e) {} } });
  }

  window.MQ_Overlays = { init: init };
})();
